import React from 'react';
import { TimePicker } from 'clad';

const Timepicker = React.forwardRef((props, ref) => {
    const { value, onChange } = props;

    const handleChange = value => {
        if (onChange) onChange(value);
    };

    return <TimePicker format="HH:mm" value={value} onChange={handleChange} />;
});

export default Timepicker;
